import { Coins, Star, Trophy } from 'lucide-react';
import React, { useState } from 'react'

function UserProfile({ Userdata, ChangeTab }) {

    const getCompletionColor = (percentage) => {
        if (percentage >= 80) return 'from-green-400 to-emerald-500';
        if (percentage >= 60) return 'from-yellow-400 to-orange-500';
        return 'from-red-400 to-pink-500';
    };

    const getCompletionStatus = (percentage) => {
        if (percentage >= 80) return 'Excellent';
        if (percentage >= 60) return 'Good';
        return 'Needs Attention';
    };

    const [userStats, setUserStats] = useState({
        ProfileCompletion: 100,
        Credits: 0
    });

    return (
        <>
            <div className="mx-auto space-y-6 p-4">
                <section className="bg-gradient-to-br from-blue-50 to-indigo-100 shadow-lg rounded-2xl p-8 border border-blue-100">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
                        <div className="flex-1">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-white font-bold text-xl">
                                    {Userdata?.name?.charAt(0) || 'U'}
                                </div>
                                <div>
                                    <h3 className="text-xl font-bold text-gray-800">Your Profile!</h3>
                                    <p className="text-gray-600">Manage your profile and settings</p>
                                </div>
                            </div>
                            <div className="bg-white/80 backdrop-blur-sm border border-white/50 rounded-xl px-6 py-3 inline-block shadow-sm">
                                <span className="text-blue-700 font-semibold text-lg">{Userdata?.name}</span>
                            </div>
                        </div>

                        <div className="text-center bg-white/80 backdrop-blur-sm border border-white/50 rounded-xl p-6 shadow-sm">
                            <div className="flex items-center justify-center gap-2 mb-3">
                                <Star className="w-5 h-5 text-yellow-500" />
                                <p className="text-sm font-semibold text-gray-700">Profile Completion</p>
                            </div>
                            <div className={`w-20 h-20 mx-auto rounded-full bg-gradient-to-br ${getCompletionColor(userStats.ProfileCompletion)} flex items-center justify-center text-white text-xl font-bold shadow-lg`}>
                                {userStats.ProfileCompletion}%
                            </div>
                            <p className="text-xs font-medium text-gray-600 mt-2">{getCompletionStatus(userStats.ProfileCompletion)}</p>
                        </div>
                    </div>
                </section>
                <section className="bg-white shadow-xl rounded-2xl p-8 border border-gray-100">
                    <div className="flex justify-between items-center mb-8">
                        <h3 className="text-2xl font-bold text-gray-800">Profile Information</h3>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                        <div className="group">
                            <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">
                                Full Name
                            </label>
                            <div className="relative">
                                <div className="px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-gray-800 font-medium">
                                    {Userdata?.name}
                                </div>
                            </div>
                        </div>

                        <div className="group">
                            <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">
                                Mobile Number
                            </label>
                            <div className="relative">
                                <div className="px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-gray-800 font-medium">
                                    {Userdata?.phone}
                                </div>
                            </div>
                        </div>

                        <div className="group">
                            <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">
                                Email Address
                            </label>
                            <div className="relative">
                                <div className="px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-gray-800 font-medium">
                                    {Userdata?.email}
                                </div>
                            </div>
                        </div>

                        <div className="group">
                            <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">
                                Password
                            </label>
                            <div className="relative">
                                <div className="px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg flex items-center justify-between text-gray-800 font-medium">
                                    <span>{"••••••••••••"}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mt-8 pt-6 border-t border-gray-200">
                        <div className="flex flex-wrap gap-3">
                            <button onClick={() => { ChangeTab('Update Profile') }} className="px-6 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200 shadow-md hover:shadow-lg font-medium">
                                Update Profile
                            </button>
                        </div>
                    </div>
                </section>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-white shadow-lg rounded-xl p-6 border border-gray-100">
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-gradient-to-br from-green-400 to-emerald-500 rounded-lg flex items-center justify-center">
                                <Trophy className="w-6 h-6 text-white" />
                            </div>
                            <div>
                                <p className="text-sm text-gray-500 font-medium">Account Status</p>
                                <p className="text-lg font-bold text-gray-800">Premium</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white shadow-lg rounded-xl p-6 border border-gray-100">
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-gradient-to-br from-purple-400 to-purple-500 rounded-lg flex items-center justify-center">
                                <Star className="w-6 h-6 text-white" />
                            </div>
                            <div>
                                <p className="text-sm text-gray-500 font-medium">Member Since</p>
                                <p className="text-lg font-bold text-gray-800">Jan 2024</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white shadow-lg rounded-xl p-6 border border-gray-100">
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-gradient-to-br from-orange-400 to-red-500 rounded-lg flex items-center justify-center">
                                <div className="text-white font-bold text-sm">99%</div>
                            </div>
                            <div>
                                <p className="text-sm text-gray-500 font-medium">Satisfaction</p>
                                <p className="text-lg font-bold text-gray-800">Excellent</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserProfile